import { useField, useFormikContext } from 'formik';
import { Input } from 'shared/components/Input';

interface FormikInputProps {
  name: string;
  [key: string]: any;
}

export const FormikInput = ({ name, ...props }: FormikInputProps) => {
  const [field, meta, helpers] = useField(name);
  const { setValue, setTouched } = helpers;
  const { validateForm } = useFormikContext();

  const clearInput = async () => {
    setTouched(true, true);
    setValue('', true).then(async () => {
      await validateForm();
    });
  };

  return (
    <Input
      {...field}
      {...props}
      error={meta.error}
      value={field.value}
      fieldProps={field}
      clearInput={clearInput}
      className={meta.touched && meta.error ? 'error' : ''}
    />
  );
};
